export default "__VITE_ASSET__BjLTOSmJ__"